import { MCP_AUTH_LANDING_PATH } from '@ti/contracts'

/**
 * The MCP consent page draws its own skeleton from its first paint, so the generic menu and content
 * one would only flash underneath it. Only the landing document itself is meant: the sign-in page
 * that returns to it keeps the ordinary loader. Doubled and trailing slashes resolve to the same route.
 */
export const isMcpLandingPath = (pathname: string): boolean =>
  pathname.replace(/\/{2,}/g, '/').replace(/\/+$/, '') === MCP_AUTH_LANDING_PATH
